<script setup lang="ts">
import AppButton from '~/components/AppButton.vue'
import type { CmsCustomComponentType } from '~/layers/cms/app/types/cmsTypes'

const props = defineProps<{
  cmsDataPath: (string | number)[]
}>()
const nazwa_komponentu = 'Teksty/CenterAndButton'
const component_default_values: CmsCustomComponentType = {
  id: { value: undefined, default_value: 'Lorem Ipsum', settingType: 'text', setting_label: 'zmien id' }
}
</script>

<template>
  <CmsCustomComponent
    v-slot="{ component_values }"
    :cms-data-path="[...props.cmsDataPath]"
    :component-name="nazwa_komponentu"
    :defaults="component_default_values"
    :open-options="true"
  >
    <div
      :id="component_values?.id?.value"
      class="px-2xl py-15 flex flex-col gap-15 items-center"
    >
      <div class="max-w-345 m-auto flex flex-col gap-5">
        <span class="text-H2 text-Tekst text-center">
          <CmsText
            :cms-data-path="[...props.cmsDataPath, 'component_data', 'text_1']"
          />
        </span>
      </div>
      <CmsLink
        v-slot="{ link }"
        :cms-data-path="[...props.cmsDataPath, 'component_data', 'link_1']"
      >
        <AppButton
          :href="link?.href"
          :target="link?.target"
          button-theme="Primary"
        >
          <span class="link-text font-bold">{{ link?.link_text ?? 'Lorem Ipsum' }}</span>
        </AppButton>
      </CmsLink>
    </div>
  </CmsCustomComponent>
</template>
